import React, { useState, useEffect } from "react";
import ReactExport from "react-data-export";
import Styles from './Styles';
import IconButton from '../../../buttons/IconButton';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const Download = props => {
    const [ dataSet, setDataSet ] = useState([{
        columns:[],
        data:[]
    }]);

    useEffect(() => {
        formatData();
    },[props.data])

    if (props.loading) {
        return null
    };

    const formatData = () => {
        let label;
        if (props.data.length > 0) {
            label = Object.keys(props.data[0]);
        } else {
            label = Object.keys([]);
        };
    
        const columns = label.reduce((r,i) => {
            r.push({
                title:i, 
                style:Styles.shippingDetailLabelStyle
            });
            return r;
        },[]);
    
        let totalItem = props.data.length;
        let totalPrice = 0; 
        let totalDiscount = 0; 
        let totalBasicPrice = 0;
        let style = Styles.shippingDetailRowLightStyle;
        const data = props.data.reduce((r,i,idx) => {
            let prevItem = idx === 0 ? props.data[0] : props.data[idx-1]
            let currentItem = props.data[idx];
      
            if (idx === 0) {
                totalPrice =  currentItem.price;
                totalDiscount =  currentItem.discount_price;
                totalBasicPrice =  currentItem.basic_price;
            };
    
            if (prevItem.order_id === currentItem.order_id) {
                style = style
            } else {
                totalPrice = totalPrice + currentItem.price;
                totalDiscount = totalDiscount + currentItem.discount_price;
                totalBasicPrice = totalBasicPrice + currentItem.basic_price;
                style = style === Styles.shippingDetailRowLightStyle ? Styles.shippingDetailRowDarkStyle : Styles.shippingDetailRowLightStyle;
            };
    
            r.push([
                {value:i.no || "", style},
                {value:i.order_id || "", style},
                {value:i.short_order_id || "", style},
                {value:i.user_id || "", style},
                {value:i.shipper_name || "", style},
                {value:i.shipper_organization || "", style},
                {value:i.shipper_email || "", style},
                {value:i.shipper_phone || "", style},
                {value:i.origin_name || "", style},
                {value:i.origin_phone || "", style},
                {value:i.origin_address || "", style},
                {value:i.origin_note || "", style},
                {value:i.origin_postal_code || "", style},
                {value:i.destination_name || "", style},
                {value:i.destination_phone || "", style},
                {value:i.destination_address || "", style},
                {value:i.destination_note || "", style},
                {value:i.destination_postal_code || "", style},
                {value:i.courier_code || "", style},
                {value:i.courier_service_code || "", style},
                {value:i.courier_tracking_id || "", style},
                {value:i.courier_link || "", style},
                {value:i.confirmed_date || "", style},
                {value:i.confirmed_time || "", style},
                {value:i.waybill_id || "", style},
                {value:i.delivery_type || "", style},
                {value:i.delivery_date || "", style},
                {value:i.delivery_time || "", style},
                {value:i.total_weight || "", style},
                {value:i.total_volume || "", style},
                {value:i.total_quantity || "", style},
                {value:i.note || "", style},
                {value:i.item_name || "", style},
                {value:i.item_description || "", style},
                {value:i.item_value || "", style},
                {value:i.item_length || "", style},
                {value:i.item_width || "", style},
                {value:i.item_height || "", style},
                {value:i.item_weight || "", style},
                {value:i.item_quantity || "", style},
                {value:i.request_type || "", style},
                {value:i.basic_price || "", style},
                {value:i.cod_amount || "", style},
                {value:i.cod_fee || "", style},
                {value:i.insurance_amount || "", style},
                {value:i.insurance_fee || "", style},
                {value:i.price || "", style},
                {value:i.status || "", style},
                {value:i.cancellation_reason || "", style},
                {value:i.created_date || "", style},
                {value:i.created_time || "", style}
            ]);
            
            return r;
        },[])
        setDataSet([{
            columns,
            data
        }])
    }

    return (
            <ExcelFile 
                filename={props.filename} 
                element={
                    <IconButton iconClassName="fas fa-file-download" >
                        Download
                    </IconButton>
                }
            >
                <ExcelSheet dataSet={dataSet} name="Shipping Details"/>
            </ExcelFile>
    );
}

export default Download;